export const portugol = hljs => {
    // Adicione aqui outras palavras-chave do Portugol
    const red = ['programa', 'funcao', 'para', 'enquanto', 'se', 'senao', 'nao', 'e', 'ou',"printf","scanf","%f","%d","%c","if","else","while","&&","%s","system","fflush"];

    const blue = ['inteiro', 'real', 'caracter', 'cadeia', 'logico', 'verdadeiro', 'falso',"float","int","char"];
    const green = ['include','stdio.h','stdlib.h','string.h']
    const numbers = ['0'];

    for (let i = 1; i <= 1000; i++) {
        numbers.push(i + '');
    }

    return {
        name: 'portugol',
        case_insensitive: true,

        // Define a regra para palavras-chave
        contains: [
            {
                className: 'red',
                begin: '\\b(' + red.join('|') + ')\\b'
            },
            {
                className: 'blue',
                begin: '\\b(' + blue.join('|') + ')\\b'
            },
            {
                className: 'green',
                begin: '\\b(' + numbers.join('|') + ')\\b'
            },
            {
                className: 'green',
                begin: '\\b(' + green.join('|') + ')\\b'
            }
        ]
    };
};
